import React, { useEffect, useState } from 'react'
import {
	ProcessingHeading,
	ProcessingSub,
	ProcessingWrap,
	StepActiveDot,
	StepBullet,
	StepDetail,
	StepLabel,
	StepRow,
	StepsList,
} from '../ItineraryImportPage.styles'
import { computeStepIndex, PROCESSING_STEPS } from '../constants'
import { Check } from './icons'
import OrbitLoader from './OrbitLoader'

interface ProcessingBodyProps {
	startedAt: number | null
}

const ProcessingBody: React.FC<ProcessingBodyProps> = ({ startedAt }) => {
	const [now, setNow] = useState(() => Date.now())
	useEffect(() => {
		const id = window.setInterval(() => setNow(Date.now()), 500)
		return () => window.clearInterval(id)
	}, [])

	const elapsedMs = startedAt ? now - startedAt : 0
	const stepIndex = computeStepIndex(elapsedMs)

	return (
		<ProcessingWrap>
			<OrbitLoader size={104} />
			<ProcessingHeading>Adding to your itinerary</ProcessingHeading>
			<ProcessingSub>
				Hang tight — this usually takes 15–90 seconds. You can close this window; we'll ping you when
				it's done.
			</ProcessingSub>
			<StepsList>
				{PROCESSING_STEPS.map((s, i) => {
					const done = i < stepIndex
					const active = i === stepIndex
					const opacity = i > stepIndex ? 0.45 : 1
					return (
						<StepRow key={s.label} $opacity={opacity}>
							<StepBullet $state={done ? 'done' : active ? 'active' : 'pending'}>
								{done ? <Check size={12} /> : active ? <StepActiveDot /> : null}
							</StepBullet>
							<div>
								<StepLabel>{s.label}</StepLabel>
								<StepDetail>{s.detail}</StepDetail>
							</div>
						</StepRow>
					)
				})}
			</StepsList>
		</ProcessingWrap>
	)
}

export default ProcessingBody
